'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/Typography/Typography.classes.tsx
var TYPO_CLASSES = {
  "display-L": "text-display-L font-display leading-tight break-words",
  "display-M": "text-display-M font-display leading-tight break-words",
  "display-S": "text-display-S font-display leading-tight break-words",
  "display-XS": "text-display-XS font-display leading-tight break-words",
  "heading-XXL": "text-heading-XXL font-heading leading-tight",
  "heading-XL": "text-heading-XL font-heading leading-tight",
  "heading-L": "text-heading-L font-heading leading-tight",
  "heading-M": "text-heading-M font-heading leading-tight",
  "heading-S": "text-heading-S font-heading leading-tight",
  "heading-XS": "text-heading-XS font-heading leading-tight",
  "heading-XXS": "text-heading-XXS font-heading leading-tight",
  "body-XL": "text-body-XL font-body",
  "body-L": "text-body-L font-body",
  "body-M": "text-body-M font-body",
  "body-S": "text-body-S font-body",
  "body-XS": "text-body-XS font-body",
  "body-XXS": "text-body-XXS font-body",
  "label-XL": "text-label-XL font-label",
  "label-L": "text-label-L font-label",
  "label-M": "text-label-M font-label",
  "label-S": "text-label-S font-label",
  "label-XS": "text-label-XS font-label",
  "label-XXS": "text-label-XXS font-label",
  "link-L": "text-body-L font-link underline",
  "link-M": "text-body-M font-link underline",
  "link-S": "text-body-S font-link underline",
  "link-XS": "text-body-XS font-link underline"
};
var COLOR_CLASSES = {
  "text-primary": "text-text-primary",
  "text-secondary": "text-text-secondary",
  "text-tertiary": "text-text-tertiary",
  "primary-400": "text-primary-400",
  primary: "text-primary",
  "primary-600": "text-primary-600",
  "primary-800": "text-primary-800",
  "secondary-400": "text-secondary-400",
  secondary: "text-secondary",
  "secondary-600": "text-secondary-600",
  "secondary-800": "text-secondary-800",
  "tertiary-400": "text-tertiary-400",
  tertiary: "text-tertiary",
  "tertiary-600": "text-tertiary-600",
  "tertiary-800": "text-tertiary-800",
  "action-400": "text-action-400",
  action: "text-action",
  "action-600": "text-action-600",
  "action-800": "text-action-800",
  "error-400": "text-error-400",
  error: "text-error",
  "error-600": "text-error-600",
  "error-800": "text-error-800",
  "success-400": "text-success-400",
  success: "text-success",
  "success-600": "text-success-600",
  "success-800": "text-success-800",
  notice: "text-notice",
  "notice-400": "text-notice-400",
  "notice-600": "text-notice-600",
  "notice-800": "text-notice-800"
};

// src/Typography/Typography.tsx
import { jsx } from "react/jsx-runtime";
var Typography = (_a) => {
  var _b = _a, {
    variant = "body-M",
    color = "text-primary",
    as,
    strong,
    className = "",
    children,
    ref
  } = _b, props = __objRest(_b, [
    "variant",
    "color",
    "as",
    "strong",
    "className",
    "children",
    "ref"
  ]);
  const Component = as || "p";
  return /* @__PURE__ */ jsx(
    Component,
    __spreadProps(__spreadValues({
      className: `${TYPO_CLASSES[variant]} ${COLOR_CLASSES[color]} ${className} ${strong ? "!font-bold" : ""}`,
      ref
    }, props), {
      children
    })
  );
};
var Typography_default = Typography;

export {
  Typography_default
};
//# sourceMappingURL=chunk-QNSUZHUC.mjs.map